import React, { Component } from 'react';
import {Form, Input, Button, Checkbox, Layout, Space, message} from "antd";
import "./login.css"
import createHistory from "history/createBrowserHistory";
import {Login} from "../../requist";
import Base64 from 'base-64';

const { Content } = Layout;

class LoginPage extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
        this.onFinish = (values) => {
            let params = {
                pwd: Base64.encode(values.pwd),
                userid:values.userid
            }
            Login(params).then((res)=>{
                if(res.result){
                    window.localStorage.removeItem('userId');
                    window.localStorage.removeItem('userToken');
                    window.localStorage.removeItem('lenovoid');
                    window.localStorage.removeItem('sst');
                    window.localStorage.setItem('userId', values.userid);
                    window.localStorage.removeItem('userInfo');
                    window.localStorage.setItem('userInfo',JSON.stringify(res.data));
                    window.localStorage.setItem('userToken',res.userToken);
                    this.props.history.push({
                        pathname: '/disputeHome'
                    })
                    window.location.reload()
                }else{
                    window.localStorage.removeItem('userId');
                    message.error(`${res.msg}`)
                }
            })
        };

        this.onFinishFailed = (errorInfo) => {
            console.log('Failed:', errorInfo);
        };
    }
    componentWillMount(){

    }
    render() {
        return <Layout className="site-layout-background" style={{ padding: '24px 0' }}>
            <Content className="loginContent" style={{ padding: '0 24px', minHeight: 280 }}>
                <Form
                    name="loginPage"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        label="Username"
                        name="userid"
                        rules={[{ required: true, message: 'Please input your username!' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="pwd"
                        rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 6, span: 16 }}>
                        <Checkbox>Remember my login on this computer</Checkbox>
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 10 }}>
                        <Space size={90}>
                            <Button type="primary" htmlType="submit">
                                Sign In
                            </Button>
                            {/*<Button type="primary">*/}
                            {/*    Sign Up*/}
                            {/*</Button>*/}
                        </Space>
                    </Form.Item>
                    {/*<Form.Item wrapperCol={{ offset: 10 }}>*/}
                    {/*    <a>Forget Password?</a>*/}
                    {/*</Form.Item>*/}
                </Form>
            </Content>
            <h4>Dear Customer</h4>
            <p>Content here is for entitled partners only and includes valuable links and content. With your Sold To number and email address you can sign up and raise a dispute. Subsequently the dispute will be processed. You can check the actual dispute status anytime in the status report of this portal.</p>
        </Layout>
    }
}

export default LoginPage;